export default "__VITE_ASSET__CCAx5NQU__"